import { GameConstants } from "../../../GameConstants";
import { BoardContainer } from "../BoardContainer";
import { GameVars } from "../../../GameVars";

export class Arrow extends Phaser.GameObjects.Container {

    private arrowMask: Phaser.GameObjects.Graphics;
    private arrow: Phaser.GameObjects.Sprite;

    private isPlayer: boolean;

    constructor(scene: Phaser.Scene, isPlayer: boolean) {
        
        super(scene);

        this.isPlayer = isPlayer;

        this.arrowMask = new Phaser.GameObjects.Graphics(this.scene);

        this.arrow = new Phaser.GameObjects.Sprite(this.scene, 0, 0, "texture_atlas_1");
        this.arrow.setOrigin(.5, 1);
        this.arrow.setScale(5);
        this.arrow.anims.play("arrow");
        this.scene.add.existing(this.arrow);
        this.add(this.arrow);

        const mask = this.arrowMask.createGeometryMask();
        this.arrow.setMask(mask);

        const strikerY = GameVars.carromEngine.strikerY;

        if (this.isPlayer) {
            this.y = strikerY * GameConstants.PHYS_SCALE;
            this.arrowMask.y = GameConstants.GAME_HEIGHT / 2 + (strikerY * GameConstants.PHYS_SCALE) * BoardContainer.currentInstance.scaleY;
        } else {
            this.y = -strikerY * GameConstants.PHYS_SCALE;
            this.arrowMask.y = GameConstants.GAME_HEIGHT / 2 - (strikerY * GameConstants.PHYS_SCALE) * BoardContainer.currentInstance.scaleY;
        }
    }

    public update(px: number, rotation: number, radius: number): void {

        this.rotation = rotation + Math.PI / 2;

        const rot = Math.PI * .5 - rotation;

        this.arrowMask.clear();
        this.arrowMask.fillStyle(0x0000FF);

        let arrowHeadP1: {x: number, y: number};
        let arrowHeadP2: {x: number, y: number};
        let arrowHeadP3: {x: number, y: number};

        const strikerRadius = GameVars.carromEngine.strikerRadius;

        if (radius > 2 * strikerRadius * GameConstants.PHYS_SCALE) {

            arrowHeadP1 = {x: 0, y: radius * BoardContainer.currentInstance.scaleY};
            arrowHeadP2 = {x: 15, y: radius * BoardContainer.currentInstance.scaleY - 20};
            arrowHeadP3 = {x: -15, y: radius * BoardContainer.currentInstance.scaleY - 20};

            arrowHeadP1 = this.transformPoint(arrowHeadP1, rot);
            arrowHeadP2 = this.transformPoint(arrowHeadP2, rot);
            arrowHeadP3 = this.transformPoint(arrowHeadP3, rot);

            const arrow_py_1 = 1.35 * strikerRadius * GameConstants.PHYS_SCALE * BoardContainer.currentInstance.scaleY;
            const arrow_py_2 = radius * BoardContainer.currentInstance.scaleY - 20;

            let arrowP1 = {x: -5, y: arrow_py_1};
            let arrowP2 = {x: 5, y: arrow_py_1};
            let arrowP3 = {x: 5, y: arrow_py_2};
            let arrowP4 = {x: -5, y: arrow_py_2};

            arrowP1 = this.transformPoint(arrowP1, rot);
            arrowP2 = this.transformPoint(arrowP2, rot);
            arrowP3 = this.transformPoint(arrowP3, rot);
            arrowP4 = this.transformPoint(arrowP4, rot);

            let arrowBaseTipPosition = {x: 0, y: arrow_py_1 * .9};
            arrowBaseTipPosition = this.transformPoint(arrowBaseTipPosition, rot);

            this.arrowMask.fillPoints(
                [  
                    arrowP1,
                    arrowBaseTipPosition,
                    arrowP2,
                    arrowP3,
                    arrowHeadP2,
                    arrowHeadP1,
                    arrowHeadP3,
                    arrowP4       
                ]
            );

        } else if (radius > 1.5 * strikerRadius * GameConstants.PHYS_SCALE) {

            const dr = 2 * strikerRadius * GameConstants.PHYS_SCALE - radius;

            arrowHeadP1 = {x: 0, y: radius * BoardContainer.currentInstance.scaleY};
            arrowHeadP2 = {x: 15 - dr * 1.5, y: radius * BoardContainer.currentInstance.scaleY - 20 + 1.5 * dr};
            arrowHeadP3 = {x: -15 + dr * 1.5, y: radius * BoardContainer.currentInstance.scaleY - 20 + 1.5 * dr};

            arrowHeadP1 = this.transformPoint(arrowHeadP1, rot);
            arrowHeadP2 = this.transformPoint(arrowHeadP2, rot);
            arrowHeadP3 = this.transformPoint(arrowHeadP3, rot);

            this.arrowMask.fillPoints(
                [  
                    arrowHeadP1,
                    arrowHeadP2,
                    arrowHeadP3
                ]
            );
        }

        this.arrowMask.x = GameConstants.GAME_WIDTH * .5 + px * BoardContainer.currentInstance.scaleX;
        this.x = px;
    }

    private transformPoint(p: {x: number, y: number}, rotation: number): {x: number, y: number} {

        let x = p.x * Math.cos(rotation) + p.y * Math.sin(rotation);
        let y = (-p.x * Math.sin(rotation) + p.y * Math.cos(rotation));

        x /= GameVars.scaleY;

        return {x: x, y: y};
    }
}
